module.exports = require('./cartocolor');



//////////////////
// WEBPACK FOOTER
// ./~/cartocolor/index.js
// module id = 28
// module chunks = 6